import React, { useState, useEffect } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { toast } from "../../utils/toast";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

const TransformQueueModal = ({ open, onClose, queueId, queues }) => {
  const classes = useStyles();
  const [targetQueueId, setTargetQueueId] = useState("");

  const handleClose = () => {
    onClose();
    setTargetQueueId("");
  };

  const handleTransform = async () => {
    try {
      if (!targetQueueId) {
        toast.error("Selecione uma fila de destino.");
        return;
      }
      
      await api.post(`/queue/${queueId}/transform`, { targetQueueId });
      toast.success("Fila convertida em subfila com sucesso!");
      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Transformar em Subfila</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Selecione a Fila Principal à qual esta fila passará a pertencer como uma Subfila (Opção).
          Atenção: A fila atual deixará de existir como Fila Principal e todos os seus atendimentos serão migrados.
        </Typography>
        <div className={classes.root}>
          <FormControl fullWidth margin="dense" variant="outlined">
            <InputLabel>Fila de Destino (Principal)</InputLabel>
            <Select
              value={targetQueueId}
              onChange={(e) => setTargetQueueId(e.target.value)}
              label="Fila de Destino (Principal)"
            >
              {queues
                .filter((q) => q.id !== queueId)
                .map((queue) => (
                  <MenuItem key={queue.id} value={queue.id}>
                    {queue.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleTransform} color="primary" variant="contained">
          Transformar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransformQueueModal;
